import React from 'react';
import DirectSellingModelContext from '../contextProviders/DirectSellingModelContext';

export default function IsDirectSellingActive(Component) {
  const C = props => {
    const { wrappedComponentRef, ...remainingProps } = props;

    return (
      <DirectSellingModelContext.Consumer>
        {directSellingModel => (
          <Component
            directSellingModel={directSellingModel}
            {...remainingProps}
            ref={wrappedComponentRef}
            wrappedComponentRef={wrappedComponentRef}
          />
        )}
      </DirectSellingModelContext.Consumer>
    );
  };

  C.displayName = `DirectSellingModel(${Component.displayName || Component.name})`;
  C.WrappedComponent = Component;

  return C;
}
